import React, { useState, useEffect, useContext } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { AuthContext } from '../../context/AuthContext';

import { rangeToButtonLabel } from '../../utils/dateHelper';
import { sortText } from '../../utils/sortHelper';

import {
  fetchJobs,
  updateJobStatus,
  clearJobFilter,
  addJobFilter,
  addJobSort,
  removeJobFilter,
  fetchDealers,
  changeDaterange,
  clearDaterange,
  createNewJob
} from '../../store/actions';

import BaseSelect from '../../components/BaseSelect';
import BaseAutocomplete from '../../components/BaseAutocomplete';
import ButtonSecondary from '../../components/ui/ButtonSecondary';
import ButtonPrimary from '../../components/ui/ButtonPrimary';
import BaseTable from '../../components/BaseTable';
import StatusCancelModal from './StatusCancelModal';
import CreateNewJobModal from './CreateNewJobModal';
import DatePicker from '../../components/DatePicker';
import ButtonClear from '../../components/ui/ButtonClear';

import './index.css';

const tableOptions = {
  columns: [
    {
      name: "Status",
      dataKey: 'status',
      type: 'select',
      isSortable: true,
      isSelectColored: true,
      selectOptions: [
        {'In progress': '#219653'},
        {'Scheduled': '#2D9CDB'},
        {'Completed': '#F2994A'},
        {'Canceled': '#EB5757'}
      ],
      options: [
        'in progress',
        'scheduled',
        'completed',
        'canceled'
      ],
      minWidth: '12rem'
    },
    {
      name: "Scheduled",
      dataKey: 'scheduledStartTime',
      type: 'date',
      isSortable: true,
    },
    {
      name: "Name",
      dataKey: 'name',
      type: 'text',
      isSortable: true,
      flexGrow: 'fg75'
    },
    {
      name: "Number",
      dataKey: 'UUID',
      type: 'id',
      isSortable: true,
      flexGrow: 'fg75-c',
    },
    {
      name: "Dealer",
      dataKey: 'dealer',
      type: 'text',
      isSortable: true,
    },
    {
      name: "Auto Make",
      dataKey: 'autoMake',
      type: 'text',
      isSortable: true,
    },
    {
      name: "Team",
      dataKey: 'countAssignedUsers',
      type: 'text-postfix',
      postfix: 'employee',
      isSortable: false,
    },
    {
      name: "Reports",
      type: 'default-link',
      isConditional: true,
      dataKey: 'reportLink',
      label: 'Download',
      isSortable: false
    }
  ]
}

const statusOptions = {
  prop: 'status',
  options: ["Any", "in progress", "scheduled", "completed", "canceled"]
};

const Jobs = (props) => {
  console.log('jobs')
  const {role} = useContext(AuthContext);
  const [currentCancelJob, setCurrentCancelJob] = useState(null);
  const [isShowDatePicker, setIsShowDatePicker] = useState(false);
  const [isShowCreateNewJob, setIsShowCreateNewJob] = useState(false);
  const [localJobs, setLocalJobs] = useState(props.jobList);
  const [selectLabels, setSelectLabels] = useState({dealer: 'Dealership', status: 'Job Status'});
  useEffect(() => {
    !props.jobList.length && props.fetchJobs();
    !props.dealerList.length && props.fetchDealers();
  }, []);

  useEffect(() => {
    const {jobList, jobFilterList, jobSort} = props;
    if (!jobList.length) {
      return setLocalJobs([]);
    }
    const filtered = jobList.filter(job => {
      let isValid = true;
      jobFilterList.getSet().forEach(filter => {
        if (job[filter.prop] !== filter.value) {
          isValid = false;
        }
      })
      return isValid;
    });
    if (!jobSort.prop) {
      setLocalJobs(filtered);
      return;
    }

    const {prop, isDesc} = jobSort;
    let sorted;
    if (prop === 'scheduledStartTime') {
      sorted = [...filtered].sort((a, b) => {
        const diff = moment(a[prop], 'YYYY-MM-DD HH:mm:ss') - moment(b[prop], 'YYYY-MM-DD HH:mm:ss');
        return isDesc ? diff : diff * -1;
      });
    } else {
      sorted = [...filtered].sort(sortText(prop, isDesc));
    }
    setLocalJobs(sorted);
  }, [props.jobList, props.jobFilterList, props.jobSort]);

  console.log('localJobs', localJobs)

  useEffect(() => {
    const filters = props.jobFilterList;
    const dealerSelectLabel = filters.getByProp('dealer');
    const statusSelectLabel = filters.getByProp('status');
    setSelectLabels({
      dealer: dealerSelectLabel ? dealerSelectLabel : 'Dealership',
      status: statusSelectLabel ? statusSelectLabel : 'Job Status',
    })
  }, [props.jobFilterList])

  const selectStatus = (job, status) => {
    if (job.status === status) return;
    if (status === 'canceled') {
      setCurrentCancelJob(job);
    } else {
      props.updateJobStatus(job.UUID, status);
    }
  }

  const choseFilter = (filterProp, filterValue) => {
    if (filterValue === 'Any') {
      return props.removeJobFilter(filterProp);
    }
    props.addJobFilter(filterProp, filterValue);
  }

  const choseSort = (column) => {
    if (!column.isSortable) return;
    const { jobSort } = props;
    props.addJobSort(column.dataKey, jobSort.prop === column.dataKey ? !jobSort.isDesc : true);
  }

  const choseDate = (date) => {
    props.changeDaterange(date)
    toggleDatePicker();
  }

  const confirmCancel = async (id) => {
    await props.updateJobStatus(id, 'canceled');
    closeModal();
  }

  const closeModal = () => {
    setCurrentCancelJob(null);
  }

  const toggleDatePicker = () => {
    setIsShowDatePicker(!isShowDatePicker);
  }

  const clearFilters = () => {
    props.clearJobFilter();
  }

  const clearDate = () => {
    props.clearDaterange();
    setIsShowDatePicker(false);
  }

  const toggleCreateNewJob = () => {
    setIsShowCreateNewJob(!isShowCreateNewJob);
  }
  console.log('tableOptions',tableOptions)
  return (
    <div className="jobs">
      <header className="header">
        <h2 className="header__title">Jobs</h2>
        {
          props.jobFilterList.length
            ? <ButtonClear onClick={clearFilters}/>
            : <span className="header__action-descriptor header__action-descriptor_jobs">Filter by</span>
        }
        <BaseAutocomplete
          type="button"
          name={selectLabels.dealer}
          selectOption={choseFilter}
          selectOptions={{prop: 'dealer', options: ['Any', ...props.shortDealerList]}}
          inputPlaceholder="Search Dealer"
        />
        <BaseSelect
          format="button"
          name={selectLabels.status}
          selectOption={choseFilter}
          selectOptions={statusOptions}
        />
        <ButtonSecondary name={rangeToButtonLabel(props.daterange)} onClick={toggleDatePicker}/>
        {
          ((role === 'admin') || (role === 'manager')) &&
          <ButtonPrimary name="Create New Job" onClick={toggleCreateNewJob}/>
        }
      </header>
      <BaseTable
        onSort={choseSort}
        onSelectStatus={selectStatus}
        data={localJobs}
        options={tableOptions}
        className="jobs__table"
        rowOnClick={(id) => props.history.push(`/jobs/${id}`)}/>
      {
        currentCancelJob &&
        <StatusCancelModal
          job={currentCancelJob}
          onConfirm={() => confirmCancel(currentCancelJob.UUID)}
          onClose={closeModal}
        />
      }
      {
        isShowDatePicker &&
        <DatePicker
          onClose={toggleDatePicker}
          onConfirm={choseDate}
          onClear={clearDate}
          onSelect={choseDate}
          startDate={props.daterange.startDate}
          endDate={props.daterange.endDate}
        />
      }
      {
        isShowCreateNewJob &&
        <CreateNewJobModal
          onClose={toggleCreateNewJob}
          selectOptions={{prop: 'dealer', options: props.shortDealerList}}
        />
      }
    </div>
  );
}

const mapStateToProps = (
  {
    jobs: {
      jobList,
      jobFilterList,
      jobSort,
      daterange
    },
    dealers: {
      dealerList,
      shortDealerList
    }
  }
) => (
  {
    jobList,
    jobFilterList,
    jobSort,
    dealerList,
    shortDealerList,
    daterange
  }
);

export default connect(mapStateToProps, {
  fetchJobs,
  updateJobStatus,
  clearJobFilter,
  addJobFilter,
  addJobSort,
  removeJobFilter,
  fetchDealers,
  changeDaterange,
  clearDaterange,
  createNewJob
})(withRouter(Jobs));
